// Decode the entities ReactQuill commonly emits. Runs after tag stripping so
// decoded angle brackets are never re-stripped; &amp; is decoded last so an
// encoded entity like &amp;lt; does not turn into a real "<".
const decodeHtmlEntities = (text: string): string =>
  text
    .replace(/&nbsp;/g, ' ')
    .replace(/&#x([0-9a-fA-F]+);/g, (_m, hex) =>
      String.fromCodePoint(parseInt(hex, 16)),
    )
    .replace(/&#(\d+);/g, (_m, dec) => String.fromCodePoint(parseInt(dec, 10)))
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&');

/**
 * @registry Strip HTML tags from a rich-text string and decode common HTML entities (&amp;, &lt;, &gt;, &quot;, &#39;, numeric/hex forms) down to a single collapsed line of plain text. Use for table cells / previews that summarize ReactQuill-authored workflow content (RFI questions, etc.).
 */
export const htmlFirstLine = (html: string | undefined): string => {
  if (!html) return '';
  const stripped = html.replace(/<[^>]*>/g, ' ');
  return decodeHtmlEntities(stripped).replace(/\s+/g, ' ').trim();
};
